import { Badge, Tooltip } from "@chakra-ui/react";
import { dateFormatter } from "../../../shared/utils/date-formatter";
import { EvvDevHelpVisitStatusEntry } from "../evv-dev-help.api";

export function EvvDevHelpBadge(props: { entry: EvvDevHelpVisitStatusEntry | undefined }) {
  const { entry } = props;
  if (entry === undefined) return <>-</>;

  if (entry.status === "AWAITING_DEV") {
    return (
      <Tooltip label={`Flagged ${dateFormatter.toDateTime(entry.flaggedAt)}`}>
        <Badge colorScheme="orange">Awaiting dev</Badge>
      </Tooltip>
    );
  }

  const handledAt = entry.handledAt === null ? "" : dateFormatter.toDateTime(entry.handledAt);
  const note = entry.handledNote?.trim() ?? "";
  return (
    <Tooltip
      label={note === "" ? `Handled ${handledAt}` : `Handled ${handledAt}: ${note}`}
      maxW="400px"
    >
      <Badge colorScheme="green">Handled</Badge>
    </Tooltip>
  );
}
